<script>
import VueQr from "vue-qr";
import {driver} from 'driver.js'
import 'driver.js/dist/driver.css'
import {download} from '@/assets/js/domToImgAndDownloadZip';
export default {
  name: "driverChannel",
  components: {
    driverChannelForm: () => import('./components/driverChannelForm.vue'),
    VueQr
  },
  data() {
    return {
      bg: require("@/assets/img/download_register.png"),
      bg1: require("@/assets/img/flow_chart.png"),
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/organizationChannel",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {type: "input", field: "channelName", name: "渠道名称", value: ""},
          {type: "input", field: "adminPhone", name: "联系电话", value: ""},
        ],
      },
      // 表头
      columns: [
        {prop: "channelName", label: "渠道名称",},
        {prop: "adminName", label: "负责人",},
        {prop: "adminPhone", label: "联系电话",},
        {prop: "notApplyDriverNum", label: "待认证司机",},
        {prop: "driverNum", label: "已认证司机",},
        {prop: "qrcode", label: "司机注册二维码",},
        {prop: "updated", label: "最近修改时间",},
      ],
      show: false,
      showQrcode: false,
      rowData: {},
      qrcodeUrl: '',
      qrcodeText: '',
      driverObj: null,
      driver: false
    }
  },
  mounted() {
    this.getDriverFn()
    this.getAppDownload()

  },
  methods: {
    async getAppDownload(){
      let url = "/api/v1/manage/appPath";
      let data = await this.$axios.get(url);
      if (data && data.code === 1 && data.data.driverPath) {
        this.qrcodeText = data.data.driverPath;
      }
    },
    getDriverFn() {
      this.driverObj = driver({
        showProgress: true,
        nextBtnText: '下一步',
        prevBtnText: '上一步',
        allowClose: false,
        doneBtnText: '完成',
        steps: [
          {element: '.add-btn', popover: {title: '开始添加渠道', description: '点击“添加渠道”按钮，即可开始添加渠道商'}},
          {
            element: '.driverChannelForm1',
            popover: {
              title: '选择归属机构',
              description: '渠道需归属于平台的机构，点击“机构名称”即可选择。默认为当前用户归属机构',
            }
          },
          {
            element: '.driverChannelForm2',
            popover: {title: '渠道名称命名', description: '您可输入15字以内的渠道名称，同一机构下渠道名称不可重复'}
          },
          {
            element: '.driverChannelForm3', popover: {
              title: '添加负责人',
              description: '为渠道负责人创建平台管理员账号后再添加该用户为负责人。负责人仅拥有查看和管理当前渠道的权限',
            }
          },
        ],
        onNextClick: () => {
          this.actionFn({type: 'add'})
          this.driverObj.moveNext()
          this.driverObj.destroy()
        },
      })
    },
    handClose() {
      this.rowData = {}
      this.show = false
      this.showCancel = false
      this.driver = false
      this.$refs.customTable.listFn()
    },
    actionFn({type, row}) {
      switch (type) {
        case "edit":
          this.rowData = row;
          this.show = true;
          break;
        case  'add':
          this.show = true
          break
        case 'look':
          this.showQrcodeFn(row)
          break
        case 'clickDriver':
          this.driver = row.driver
          this.getDriverFn()
          this.driverObj.drive()
          break
        case 'data':
          this.$router.push({
            path: "/driverChannelData",
            query: {
              channelId: row.id,
              organizationId: row.organizationId
            }
          })
          break
        case 'delete':
          this.$confirm("删除渠道后，司机后续无法再注册到该渠道，是否确认删除？", "删除渠道").then(async () => {
            const {code} = await this.$axios.delete("/api/v1/manage/organizationChannel", {id: row.id});
            if (code === 1) {
              this.$message.success("删除成功");
              this.$refs.customTable.listFn();
            }
          });
          break
      }
    },
    async showQrcodeFn(row) {
      const url = "/api/v1/manage/organization/qrcode/" + row.organizationId;
      const {data, code} = await this.$axios.get(url);
      if (data && code === 1) {
        this.qrcodeUrl = `${data.url}/#/register?organizationId=${data.organizationId}&appKey=${data.appKey}&channelId=${row.id}&appPath=${data.appPath}`
        this.showQrcode = true
      }
    },
    downloadAppPath() {
      // let oQrcode = document.getElementsByClassName("qr-code-down4")[0];
      // let a = document.createElement("a");
      // a.href = oQrcode.src;
      // a.download = "司机注册二维码";
      // a.click();
      this.$nextTick(() => {
        download(document.querySelectorAll(".download_material_down1"),["司机注册二维码", "司机注册物料图","司机认证物料图"]);
      })
    },
  }
}
</script>

<template>
  <div>
    <custom-table :addText="mixinUserInfo.type === 3?'':'添加渠道'" @addFn="actionFn({ type: 'add'})"
                  has-organization="true" ref="customTable"
                  :customOptions="customOptions" :columns="columns"
                  labelWidth="135" style="height: 100%">
      <template slot="customTable-top">
        <div slot="customTable-top">
          <div class="blueInfo">
            <p>* 渠道资源为机构招募的下属渠道商，渠道商拥有招募司机的权限<span
                v-if="mixinUserInfo.type !== 3">，如何</span><span
                @click="actionFn({type: 'clickDriver',row:{driver:true}})" class="util-click-text"
                v-if="mixinUserInfo.type !== 3">添加渠道</span> ?</p>
          </div>
        </div>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'updated'">{{ row.updated | filterTime }}</template>
        <template
            v-else-if="['serviceTime','latestDepartureTime','created','finishTime'].includes(item.prop)">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop === 'qrcode'">
          <el-button type="text" @click="actionFn({type: 'look', row})" size="mini">查看</el-button>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" align="center" width="148px">
          <div slot-scope="{row}">
            <el-button style="margin-right: 12px" type="text" @click="actionFn({ type: 'edit',row: row})" size="mini"
                       v-if="mixinUserInfo.type !== 3">编辑
            </el-button>
            <el-dropdown @command="actionFn" size="mini"
                         type="primary">
              <el-button size="mini" type="text">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">

                <el-dropdown-item :command="{type:'data',row:row}">
                  数据
                </el-dropdown-item>
                <el-dropdown-item :command="{type:'delete',row:row}">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </el-table-column>
      </template>
    </custom-table>

    <el-dialog destroy-on-close :visible.sync="show" :title="rowData.id?'编辑渠道':'添加渠道'" width="450px"
               :before-close="handClose">
      <driverChannelForm @driverPrev="actionFn({type: 'clickDriver',row:{driver:true}})" :driver="driver" v-if="show"
                         :rowData="rowData"
                         @handClose="handClose"></driverChannelForm>
    </el-dialog>
    <el-dialog title="注册二维码" :visible.sync="showQrcode" width="400px" :close-on-click-modal="false">
      <div>
        <div class="flex-center download_material_down1" >
          <vue-qr class="qr-code-down4" :text="qrcodeUrl" :margin="12" colorDark="#0288FF" height="220" width="220"/>
        </div>
        <div class="download_material download_material_down1" >
          <img class="bg" :src="bg" alt="">
          <vue-qr class="qr-code download_material_code" :text="qrcodeUrl" :margin="12" colorDark="#0288FF" height="300" width="300"/>
        </div>
        <div class="download_material1 download_material_down1">
          <img class="bg" :src="bg1" alt="">
          <vue-qr class="qr-code download_material_code" :text="qrcodeUrl" :margin="12" colorDark="#0288FF" height="280" width="280"/>
          <vue-qr class="qr-code-down download_material_code1" :text="qrcodeText" :margin="11" colorDark="#7EBF50" :size="350"/>
        </div>
        <div class="flex-center" style="margin-top: 20px">
          <el-button style="width: 100px" @click="showQrcode = false">取消</el-button>
          <el-button style="width: 100px" type="primary" @click="downloadAppPath">下载二维码</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
 .download_material{
    width: 750px;
    height: 1620px;
    position: fixed;
    top: 9999px;
    left: 9999px;
    z-index: -1;
    .bg{
      width: 750px;
      height: 1620px;
    }

    .download_material_code{
      position: absolute;
      top: 533px;
      left: 226px;
    }
  }
  .download_material1 {
    width: 750px;
    height: 7030px;
    position: relative;
    position: fixed;
    top: 9999px;
    left: 9999px;
    z-index: -1;
    .download_material_code{
      position: absolute;
      top: 564px;
      left: 236px;
    }
    

    .download_material_code1{
      position: absolute;
      bottom: 306px;
      left: 200px;
    }
  }
</style>